module.exports = __webpack_public_path__ + "static/media/logo.117553a9.png";